// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__5lyF0","list":"styles_list__GNxms"};